"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateBrandMapStatusBodyToJSON = exports.UpdateBrandMapStatusBodyFromJSONTyped = exports.UpdateBrandMapStatusBodyFromJSON = void 0;
var _1 = require("./");
function UpdateBrandMapStatusBodyFromJSON(json) {
    return UpdateBrandMapStatusBodyFromJSONTyped(json, false);
}
exports.UpdateBrandMapStatusBodyFromJSON = UpdateBrandMapStatusBodyFromJSON;
function UpdateBrandMapStatusBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': (0, _1.BrandMapStatusFromJSON)(json['status']),
    };
}
exports.UpdateBrandMapStatusBodyFromJSONTyped = UpdateBrandMapStatusBodyFromJSONTyped;
function UpdateBrandMapStatusBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': (0, _1.BrandMapStatusToJSON)(value.status),
    };
}
exports.UpdateBrandMapStatusBodyToJSON = UpdateBrandMapStatusBodyToJSON;
